export const RECAPTCHA_FAILED_ERR_MSG = 'validation.recaptcha.failed';
export const RECAPTCHA_REQUIRED_ERR_MSG = 'validation.recaptcha.required';
